var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view'),_c('LoadingApp')],1),_c('v-footer',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("E-Budget PT. Fastana Logistik Indonesia")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }